import React from 'react';
import {useSelector} from "react-redux";
import {bbFindEntityWithinPortfolioOrSelf} from "../../util/bbHelpers";

export const BRBIzInitialTourSocialPremium = {
    url: `/board/BreachRisk/Business/Report/Social`,
    type: `tutorial`,
    user: {
        first_login: true,
    },
    entity: {
        verified_ownership: true,
        hasScores: null,
        subscription: "Business",
        subLevel: ["premium"],
    },
    openingModal: {
        icon: null,
        heading: "Social Testing Beyond The Usual",
        description: <div className={"text-center"}>
            <p><small><i>Social Testing requires a Premium subscription, but all subscriptions can see what email addresses we were able to collect from your company.</i></small></p>
            {/*<p>*/}
            {/*    Ensure you've enabled social testing to get started today.*/}
            {/*</p>*/}
            <p>
                Social Testing capabilities find identities and send carefully crafted attacks. In addition to seeing if your team <i>opens</i> these attacks, we report back on whether we were able to execute an attack.
            </p>
            <p>
                Find the people and email addresses we've associated with your company as well as all details about social campaigns on this page.
            </p>
        </div>
    },
    tourSteps: {
        1: {
            step: 1,
            title: "Social Engineering",
            placement: "left",
            content: "Ensure you've enabled social testing to get started today.",
            scrollToElement: null,
            anchorEl: "#tourEnableTesting",
            element: null,
            last: false,
        },
        2: {
            step: 2,
            title: "Identities Trends",
            placement: "left",
            content: "Track the visibility of your company's social landscape over time.",
            scrollToElement: "#tourSocialStepOne",
            anchorEl: "#tourIdSocialHistory",
            element: null,
            last: false,
        },
        3: {
            step: 3,
            title: "Active Identities",
            content: "This table has all the identities we've discovered and any you've added for testing. ",
            placement: "top-center",
            scrollToElement: "#tourSocialIdentitiesTable",
            anchorEl: "#tourIdentitiesChart",
            element: null,
            last: false,
        },
        4:{
            step: 4,
            title: "Add New Identity",
            content: "If there are people we haven't discovered yet that you'd like to have included in a social campaign, you can add them here or on the Verifications Page.",
            placement: "top-center",
            scrollToElement: null,
            anchorEl: "#tourIdentitiesChart",
            element: document.getElementsByClassName("highlightAddITElementButton"),
            last: false,
        },
        5:{
            step: 5,
            placement: "left",
            title: "Remove Emails from Testing",
            content: "If an email address or identity should not be included in testing, you can set them out of scope here. These will not be included in any social campaigns until you toggle them back into scope.",
            scrollToElement: null,
            anchorEl: "#tourSetScope",
            element: document.getElementsByClassName("tourSetScopeCol"),
            last: false,
        },
        6:{
            step: 6,
            title: "Track Responses to Social Testing",
            content: "Use this chart to get an overview of the twenty most recent social campaigns and your company's responses. This chart will show the number of tests sent as well as individual actions, like executions and breahces.",
            scrollToElement: "#tourSocialResponseOverview",
            anchorEl: "#tourSocialResponseChart",
            element: null,
            last: false,
        },
        7:{
            step: 7,
            title: "Phishing Test Response",
            content: "Select the campaign date to see more in depth details about the email sent, emails it was sent too, and individual responses.",
            scrollToElement: null,
            anchorEl: "#tourPhishingTestResponseTable",
            element: null,
            last: false,
        },
        8:{
            step: 8,
            title: "Test Sent To",
            placement: "left",
            content: "Click the email address to view more detailed information about the email address and person it was sent to.",
            scrollToElement: null,
            anchorEl: "#tourStepIdDetailsHeader",
            element: document.getElementsByClassName("tourStepIdentitiesCol"),
            last: false,
        },
        9:{
            step: 9,
            title: "Response At A Glance",
            placement: "left",
            content: "See whether the phishing email was opened, executed, or resulted in a breach at a glance.",
            scrollToElement: null,
            anchorEl: "#tourStepResponseIcons",
            element: document.getElementsByClassName("tourStepResponseCol"),
            last: false,
        },
        10:{
            step: 10,
            title: "View Details",
            placement: "left",
            content: "Take an in depth look at any actions or responses by clicking here.",
            scrollToElement: null,
            anchorEl: "#tourStepDetailsHeader",
            element: document.getElementsByClassName("tourStepResponseDetailsCol"),
            last: true,
        },
    },
    style: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        maxWidth: "750px",
        // width: 400,
        // height: 250,
        background: 'white',
        borderRadius: "10px",
        // border: '1px solid #000',
        boxShadow: 24,
        p: 4,
        // zIndex: 1502,
    }
}